import { useState } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { Dropdown, RadioButton, Textarea, TextField } from '@marketplace/ui-elements';
 
import { TAddApplicationFormProps } from './add-edit-app-form.types';
 
import classes from './add-edit-app-form.module.scss';
import useAddAppForm from './add-edit-app-form.hook';
 
export const AddEditApplicationForm = (props: TAddApplicationFormProps): JSX.Element => {
  const { formatMessage }: IntlShape = useIntl();
 
  const [facing, setFacing] = useState(props.application?.facing ?? 'PROVIDER');
 
  const { appProductsDropdownOptions, providerCategoryDropdownOptions, patientCategoryDropdownOptions, intendedUserDropdownOptions ,intendedPurposesDropdownOptions } =
    useAddAppForm();
 
  const currentOptions = facing === 'PROVIDER' ? providerCategoryDropdownOptions : patientCategoryDropdownOptions;
 
  const radioButtonOnChangeHandler = (e: any) => {
    setFacing(e.value);
    props.setValue('facing', e.value);
    props.setValue('categories', []);
  };
 
  return (
    <form
      className={classes.modalContent}
      onSubmit={props.handleSubmit(props.onSubmit)}
      ref={props.formRef}
      id="add-application-form"
    >
      <div className={classes.multiComponentWrapper}>
        <TextField
          name="name"
          fieldId="name"
          autoComplete="off"
          isRequired
          autoFocus
          maxLength={100}
          control={props.control}
          error={props.formState.errors.name?.message}
          placeholder={formatMessage(
            { id: 'generalForm_placeholder_select' },
            {
              field: formatMessage({
                id: 'addApplicationModal_applicationName',
              }),
            }
          )}
          rootClassName={classes.appTextField}
          label={formatMessage({
            id: 'addApplicationModal_applicationName',
          })}
        />
        <div className={classes.facingWrapper && classes.field}>
          <div className={classes.facingLabel}>
            {formatMessage({ id: 'addApplicationModal_facing_label' })}
            <span className={classes.asterix}>*</span>
          </div>
          <div className={classes.radioGroup}>
            <RadioButton
              control={props.control}
              name="facing"
              label={formatMessage({ id: 'addApplicationModal_provider' })}
              className={classes.radioItem}
              fieldId="provider"
              value="PROVIDER"
              onChange={(e) => radioButtonOnChangeHandler(e)}
              checked={facing === 'PROVIDER'}
            />
            <RadioButton
              control={props.control}
              label={formatMessage({ id: 'addApplicationModal_patient' })}
              className={classes.radioItem}
              fieldId="patient"
              name="facing"
              value="PATIENT"
              onChange={(e) => radioButtonOnChangeHandler(e)}
              checked={facing === 'PATIENT'}
            />
          </div>
        </div>
      </div>
      <Textarea
        name="short_description"
        fieldId="short_description"
        isRequired
        maxLength={251}
        control={props.control}
        error={props.formState.errors.short_description?.message}
        placeholder={formatMessage(
          { id: 'generalForm_shortDescription_placeholder' },
          {
            field: formatMessage({
              id: 'addApplicationModal_shortDescription',
            }),
          }
        )}
        rootClassName={classes.rootTextField}
        textareaClassName={classes.textField}
        label={formatMessage({
          id: 'addApplicationModal_shortDescription',
        })}
      />
      <Dropdown
        name="intendedUsers"
        fieldId="intendedUsers"
        isRequired
        multi
        options={intendedUserDropdownOptions}
        control={props.control}
        error={props.formState.errors.intendedUsers?.message}
        placeholder={formatMessage(
          { id: 'generalForm_placeholder_select' },
          {
            field: formatMessage({
              id: 'addApplicationModal_intendedUser',
            }),
          }
        )}
        rootClassName={classes.intendedUserfield}
        label={formatMessage({
          id: 'addApplicationModal_intendedUserTitle',
        })}
      />
      <div className={classes.multiComponentWrapper}>
        <Dropdown
          name="products"
          fieldId="products"
          isRequired
          multi
          options={appProductsDropdownOptions}
          control={props.control}
          maxSelectedLabels = {1}
          error={props.formState.errors.products?.message}
          placeholder={formatMessage(
            { id: 'generalForm_placeholder_select' },
            {
              field: formatMessage({
                id: 'addApplicationModal_work_with',
              }),
            }
          )}
          rootClassName={classes.field}
          label={formatMessage({ id: 'addApplicationModal_work_with' })}
        />
 
        <Dropdown
          name="categories"
          fieldId="categories"
          isRequired
          multi
          options={currentOptions}
          control={props.control}
          maxSelectedLabels = {1}
          error={props.formState.errors.categories?.message}
          placeholder={formatMessage(
            { id: 'generalForm_placeholder_select' },
            {
              field: formatMessage({
                id: 'addApplicationModal_category',
              }),
            }
          )}
          rootClassName={classes.categoryRoot}
          label={formatMessage({ id: 'addApplicationModal_category' })}
        />
      </div>
      <Dropdown
        name="intendedPurposes"
        fieldId="intendedPurposes"
        isRequired
        multi
        options={intendedPurposesDropdownOptions}
        control={props.control}
        error={props.formState.errors.intendedPurposes?.message}
        placeholder={formatMessage(
          { id: 'generalForm_placeholder_select' },
          {
            field: formatMessage({
              id: 'addApplicationModal_intendedPurpose',
            }),
          }
        )}
        rootClassName={classes.field}
        label={formatMessage({ id: 'addApplicationModal_intendedPurposeTitle' })}
      />
      {/* The button below allow submit form on Enter */}
      <button hidden tabIndex={-1} />
    </form>
  );
};